<template>
  <a-flex gap="large">
    <a-button
      type="primary"
      :loading="saveButtonLoading"
      @click="saveLabelTemplate"
    >
      Сохранить
    </a-button>

    <a-button type="primary" :loading="loading" @click="printLabelTemplate">
      Отправить на печать
    </a-button>

    <a-button type="primary" :loading="loading" @click="downloadLabelTemplate">
      Скачать этикетку
    </a-button>
  </a-flex>
</template>

<script setup lang="ts">
import { useLabelTemplateStore } from "@/stores/labelTemplate/labelTemplateStore";
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { computed } from "vue";
import { enumStatusLoad } from "@/tools/enumStatusLoad";
import { useRouter } from "vue-router";

const props = defineProps<{ loading: boolean; isCommon?: boolean }>();

const labelTemplateStore = useLabelTemplateStore();
const labelTemplateFormStore = useLabelTemplateFormStore();
const router = useRouter();

const emit = defineEmits(["saveClicked"]);

const printLabelTemplate = () => {
  if (labelTemplateStore.currentEditingLabelClass) {
    labelTemplateStore.currentEditingLabelClass.printLabel();
  }
};

const saveButtonLoading = computed(
  () =>
    labelTemplateStore.createPersonalLabelTemplateStatus ===
      enumStatusLoad.LOADING ||
    labelTemplateStore.updatePersonalLabelTemplateStatus ===
      enumStatusLoad.LOADING ||
    props.loading,
);

const saveLabelTemplate = async () => {
  if (props.isCommon && !labelTemplateStore.isAdminAccount) {
    return;
  }

  const label = labelTemplateFormStore.createLabelTemplateFromState();

  if (label) {
    if (label.id) {
      const saved = props.isCommon
        ? await labelTemplateStore.updateCommonLabelTemplate(label)
        : await labelTemplateStore.updatePersonalLabelTemplate(label);

      if (saved) {
        emit("saveClicked");
      }
    } else {
      const created = props.isCommon
        ? await labelTemplateStore.createCommonLabelTemplate(label)
        : await labelTemplateStore.createPersonalLabelTemplate(label);

      if (created) {
        await router.push({ name: "labels" });
      }
    }
  }
};

const downloadLabelTemplate = () =>
  labelTemplateStore.currentEditingLabelClass?.downloadLabel();
</script>

<style scoped lang="scss"></style>
